import axios from "axios"
import {APP_URL} from '../config'

const api = axios.create({
    withCredentials: true,
    baseURL: APP_URL,
    headers:{
        "X-Requested-With": "XMLHttpRequest"
    }
})


export default api